<template>
  <section
    :class="[
      { 'is-collapsed': !isOpen, 'is-shine': shine, 'is-error': error },
      `theme-${theme}`,
    ]"
    class="collapsed-panel"
  >
    <div class="collapsed-panel__box">
      <div
        class="collapsed-panel__head"
        tabindex="0"
        :aria-expanded="isOpen"
        :aria-controls="`collapse-${_uid}`"
        @click="handleClick"
        @keydown.enter.prevent="handleClick"
      >
        <div class="collapsed-panel__title">
          <slot v-bind="{ isOpen }" name="title">Заголовок</slot>
        </div>
        <button
          v-if="collapsible"
          :title="isOpen ? 'Свернуть' : 'Развернуть'"
          :class="{ minus: isOpen }"
          class="collapsed-panel__button"
        >
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
    <div
      :id="`collapse-${_uid}`"
      :style="styles"
      :aria-hidden="!isOpen"
      class="collapsed-panel__body"
    >
      <div ref="body" class="collapsed-panel__body-inner">
        <slot v-bind="{ isOpen }"></slot>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CollapsedPanel",
  props: {
    opened: Boolean,
    collapsible: {
      type: Boolean,
      default: true,
    },
    shine: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: "default",
    },
  },
  data() {
    return {
      maxHeight: 400,
      isOpen: this.opened,
      timer: null,
      speed: 600,
      ended: true,
    };
  },
  computed: {
    styles() {
      const { isOpen, ended, opened } = this;
      if (isOpen && !ended) {
        return {
          maxHeight: this.maxHeight + "px",
        };
      } else if (opened && isOpen) {
        return {
          maxHeight: this.maxHeight + "px",
          visibility: "visible",
        };
      } else if (!isOpen) {
        return {
          maxHeight: 0,
          visibility: "hidden",
        };
      } else {
        return null;
      }
    },
  },
  watch: {
    opened: {
      handler(val) {
        if (val) {
          this.handleOpen();
        }
      },
    },
  },
  mounted() {
    this.maxHeight = this.$refs.body.scrollHeight + 30;
  },
  methods: {
    handleClose() {
      if (this.isOpen) {
        this.$emit("panel:close");
        this.timer = setTimeout(() => {
          this.isOpen = !this.isOpen;
        }, 60);
      }
    },
    handleOpen() {
      if (!this.isOpen) {
        this.$emit("panel:open");
        this.timer = setTimeout(() => {
          this.ended = true;
        }, this.speed);
        this.$nextTick(() => {
          this.isOpen = !this.isOpen;
        });
      }
    },
    handleClick() {
      if (!this.collapsible) return;
      this.maxHeight = this.$refs.body.scrollHeight + 30;
      clearTimeout(this.timer);
      this.ended = false;
      this.$emit("panel:toggle", !this.isOpen);
      if (this.isOpen) {
        this.handleClose();
      } else {
        this.handleOpen();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.collapsed-panel {
  background-color: #fff;
  border: 1px solid @blue-color;

  &__box {
    padding: 20px;
  }
  &__body {
    transition: max-height 0.4s ease-out, opacity 0.175s 0.3s;
    opacity: 1;

    &-inner {
      padding: 20px 30px;
      background-color: @background-blue;
      border-top: 1px solid @blue-color;

      @media (max-width: @screen-xs-max) {
        & {
          padding: 20px;
        }
      }
    }
  }

  &.is-collapsed &__body {
    max-height: 0;
    overflow: hidden;
    opacity: 0;
  }

  &__head {
    cursor: pointer;
    user-select: none;
    position: relative;
    padding-right: 50px;

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: -20px;
      right: -20px;
      top: -20px;
      bottom: -20px;
    }
  }

  &.is-shine {
    box-shadow: 0 0 5px 0 @primary-color;
  }
  &__button {
    color: #ecf0f1;
    background: transparent;
    width: 32px;
    height: 32px;
    border: 0;
    font-size: 1.5em;
    position: absolute;
    top: 15%;
    right: 0;
    cursor: pointer;

    &:hover {
      & span {
        background: darken(@primary-color, 10%);
      }
    }

    & span {
      position: absolute;
      background: @primary-color;
      border-radius: 2px;
      transition: all 0.3s;
    }

    & span:first-child {
      top: 25%;
      bottom: 25%;
      width: 10%;
      left: 45%;
    }

    & span:last-child {
      left: 25%;
      right: 25%;
      height: 10%;
      top: 45%;
    }

    &.minus span {
      transform: rotate(90deg);
    }

    &.minus span:last-child {
      left: 50%;
      right: 50%;
    }
  }
}
</style>
